import { render, staticRenderFns } from "./OrderReturnDifference.vue?vue&type=template&id=c9185548"
import script from "./OrderReturnDifference.vue?vue&type=script&lang=js"
export * from "./OrderReturnDifference.vue?vue&type=script&lang=js"
import style0 from "./OrderReturnDifference.vue?vue&type=style&index=0&id=c9185548&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports